import type { EntityType } from './extensions/EntityReference';
import { fetchPlanById } from '../api/plans';
import { fetchConventionById } from '../api/conventions';
import { fetchCompletionReportById } from '../api/completionReports';
import { fetchPostMortemById } from '../api/postMortems';
import { fetchCoActionById } from '../api/coActions';
import { fetchCodeReviewById } from '../api/codeReviews';
import { fetchDocumentById } from '../api/documents';
import { fetchSkillById } from '../api/skills';
export const fetchEntityTitle = async (
  token: string,
  projectId: string,
  entityType: EntityType,
  entityId: string,
): Promise<string> => {
  switch (entityType) {
    case 'plan': {
      const entity = await fetchPlanById(token, projectId, entityId);
      return entity.title;
    }
    case 'convention': {
      const entity = await fetchConventionById(token, projectId, entityId);
      return entity.title;
    }
    case 'completionReport': {
      const entity = await fetchCompletionReportById(token, projectId, entityId);
      return entity.title;
    }
    case 'postMortem': {
      const entity = await fetchPostMortemById(token, projectId, entityId);
      return entity.title;
    }
    case 'coAction': {
      const entity = await fetchCoActionById(token, projectId, entityId);
      return entity.title;
    }
    case 'codeReview': {
      const entity = await fetchCodeReviewById(token, projectId, entityId);
      return entity.title;
    }
    case 'document': {
      const entity = await fetchDocumentById(token, projectId, entityId);
      return entity.title;
    }
    case 'skill': {
      const entity = await fetchSkillById(token, projectId, entityId);
      return entity.title;
    }
    default:
      throw new Error(`Unsupported entity type: ${entityType}`);
  }
};
